import { textAlign } from "@mui/system";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";
import {
  fetchAllApprovalList,
  fetchAllPendngList
} from "../../../../../services/fetchListingData";
import {
  colorBlack,
  colorWhite
} from "../../../../../utility/constants/colorManager";
import {
  APPROVE,
  RNCAPPROVED,
  STATUS_CODE_200
} from "../../../../../utility/constants/valueConstants";
import { validateUpi } from "../../../../../utility/emailValidator";
import ResizeListner from "../../../../../utility/ResizeListner";
import { SidList } from "../../../../../utility/TableHeaders";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import CustomModal from "../../../../components/main_comps/custom_modal";
import CustomTable from "../../../../components/main_comps/custom_table";

const ViewMoreSid = ({
  onClickCancel,
  clientId,
  selectedServiceProvider,
  onSuccess
}) => {
  const [cid, setCid] = useState("");
  const [sid, setSid] = useState("");
  const [upi, setUpi] = useState("");
  const [mcc, setMcc] = useState("");
  const [authKey, setAuthKey] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const inputStyle = {
    alignSelf: "center",
    height: 40,
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    boxSizing: "border-box",
    width: "100%",
    backgroundColor: "#FFFFFF",
    color: "#697D95",
    maxWidth: 500,
    minWidth: 250,
    width: 350
  };
  const containerStyle = {
    padding: 0,
    maxWidth: 500,
    minWidth: 250,
    width: 350,
    height: "40px",
    border: "1px solid #CBCACA",
    borderRadius: "5px"
  };

  const handleSave = () => {
    if (!cid && selectedServiceProvider === "KOPAY") {
      enqueueSnackbar("Please Enter CID", {
        variant: "error"
      });
      return;
    }

    if (
      !sid &&
      (selectedServiceProvider === "KOPAY" ||
        selectedServiceProvider === "NPST")
    ) {
      enqueueSnackbar("Please Enter SID", {
        variant: "error"
      });
      return;
    }
    if (!sid && selectedServiceProvider === "1PAY") {
      enqueueSnackbar("Please Enter Merchant Id", {
        variant: "error"
      });
      return;
    }
    if (!authKey && selectedServiceProvider === "1PAY") {
      enqueueSnackbar("Please Enter Merchant Api Key", {
        variant: "error"
      });
      return;
    }
    if (
      !mcc &&
      (selectedServiceProvider === "1PAY" || selectedServiceProvider === "NPST")
    ) {
      enqueueSnackbar("Please Enter Mcc code", {
        variant: "error"
      });
      return;
    }
    if (!validateUpi(upi)) {
      enqueueSnackbar("Please Enter Valid  UPI", {
        variant: "error"
      });
      return;
    }
    ApiRequestPost.updatedClientCid({
      clientId: clientId,
      vba: upi,
      cid: cid,
      sid:
        selectedServiceProvider === "KOPAY" ||
        selectedServiceProvider === "NPST"
          ? sid
          : "",
      merchantId: selectedServiceProvider === "1PAY" ? sid : "",
      authKey: authKey,
      mcc: mcc,
      serviceProviderName: selectedServiceProvider
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success"
          });
          onSuccess();
          // navigate("/approval/list");
        } else {
          enqueueSnackbar(response.message, {
            variant: "error"
          });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error"
        });
      });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <div>
        <div style={{ textAlign: "center" }}>Enter the Details </div>
        {selectedServiceProvider === "KOPAY" && (
          <div style={{ marginTop: 20 }}>
            <label style={{ fontSize: 14, lineHeight: 2 }}>CID</label>
            <CustomInput
              value={cid}
              onChange={(data) => setCid(data)}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Enter the CID "
              validator="alphaNum"
              type="input"
              inputStyles={{
                ...containerStyle
              }}
            />
          </div>
        )}
        {(selectedServiceProvider === "KOPAY" ||
          selectedServiceProvider === "NPST") && (
          <div style={{ marginTop: 20 }}>
            <label style={{ fontSize: 14, lineHeight: 2 }}>SID</label>
            <CustomInput
              value={sid}
              onChange={(data) => setSid(data)}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Enter the SID "
              validator="sid"
              type="input"
              inputStyles={{
                ...containerStyle
              }}
            />
          </div>
        )}

        {selectedServiceProvider === "1PAY" && (
          <>
            <div style={{ marginTop: 20 }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>Merchant Id</label>
              <CustomInput
                value={sid}
                onChange={(data) => setSid(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Enter the Merchant Id "
                validator="sid"
                type="input"
                inputStyles={{
                  ...containerStyle
                }}
              />
            </div>
          </>
        )}

        {(selectedServiceProvider === "NPST" ||
          selectedServiceProvider === "1PAY") && (
          <>
            <div style={{ marginTop: 20 }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>Mcc code</label>
              <CustomInput
                value={mcc}
                onChange={(data) => setMcc(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Enter the Mcc code"
                validator="mcc"
                type="input"
                inputStyles={{
                  ...containerStyle
                }}
              />
            </div>
          </>
        )}
        {selectedServiceProvider === "1PAY" && (
          <div style={{ marginTop: 20 }}>
            <label style={{ fontSize: 14, lineHeight: 2 }}>
              Merchant Api Key
            </label>
            <CustomInput
              value={authKey}
              onChange={(data) => setAuthKey(data)}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Enter the Merchant Api Key"
              validator={"alphaNum2"}
              type="input"
              inputStyles={{
                ...containerStyle
              }}
            />
          </div>
        )}

        <div style={{ marginTop: 20, marginBottom: 20 }}>
          <label style={{ fontSize: 14, lineHeight: 2 }}>UPI</label>
          <CustomInput
            value={upi}
            onChange={(data) => setUpi(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Enter the UPI ID"
            validator="upi"
            type="input"
            inputStyles={{
              ...containerStyle
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            width: "fit-content",
            gap: 20,
            margin: "auto"
          }}
        >
          <CustomButton
            title="Cancel"
            styles={{
              backgroundColor: colorWhite,
              border: "1px solid black",
              padding: 0,
              height: "auto",
              padding: "10px"
            }}
            textStyles={{
              color: colorBlack
            }}
            onClick={onClickCancel}
          />
          <CustomButton title="Submit" onClick={handleSave} />
        </div>
      </div>
    </div>
  );
};

function Sid({ clientData }) {
  console.log("coming into sid");
  const { width, height } = ResizeListner();
  const [row, setRow] = useState({});
  const [selectedServiceProvider, setSelectedServiceProvider] = useState("");
  const [data, setData] = useState({});
  const [totalElements, setTotalElements] = useState(100);
  const [totalPages, setTotalPages] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [onClickViewMore, setOnClickViewMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const approvalData = useSelector((state) => state.listingSlice.approvalList);
  // const aclData = useSelector((state) => state.aclSlice.aclList);

  useEffect(() => {
    dispatch(
      fetchAllApprovalList({
        dateRange: "",
        page: 0,
        size: 10,
        activeStatus: "",
        onBoardedStatus: RNCAPPROVED,
        userRefId: ""
      })
    );
  }, []);

  useEffect(() => {
    if (row) {
      let obj = row?.service?.find(
        (o) => o.serviceType?.toUpperCase() === "PAYIN"
      );
      if (obj) {
        setSelectedServiceProvider(obj?.serviceProviderName?.toUpperCase());
      }
    }
  }, [row]);

  return (
    <div>
      <div style={{ padding: "0px 20px", overflow: "hidden" }}></div>
      <CustomTable
        styles={{
          maxHeight: height * 0.7,
          minHeight: height * 0.7
        }}
        currentPage={approvalData?.currentPageNo - 1}
        data={approvalData?.clients}
        headers={SidList}
        totalElements={approvalData?.totalRecords}
        totalPages={approvalData?.totalPages}
        handlePaginate={(page) => {
          setCurrentPage(page);
          dispatch(
            fetchAllApprovalList({
              dateRange: "",
              page: page + 1,
              size: 10,
              // activeStatus: { ACTIVE },
              onBoardedStatus: RNCAPPROVED,
              userRefId: ""
            })
          );
        }}
        onViewMore={(row) => {
          setRow(row);
          setOnClickViewMore(true);
        }}
        loading1={loading}
      />
      {onClickViewMore && (
        <CustomModal
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800
          }}
          open={onClickViewMore}
          isBackRequired={false}
          isHeaderRequired={false}
          onClose={() => {
            setOnClickViewMore(false);
          }}
        >
          <ViewMoreSid
            onClickCancel={() => {
              setOnClickViewMore(false);
            }}
            onChange={(val) => {
              setData({ ...val });
            }}
            clientId={row?.userId}
            onSuccess={() => {
              setOnClickViewMore(false);
              dispatch(
                fetchAllApprovalList({
                  dateRange: "",
                  page: 0,
                  size: 10,
                  activeStatus: "",
                  onBoardedStatus: RNCAPPROVED,
                  userRefId: ""
                })
              );
            }}
            selectedServiceProvider={selectedServiceProvider}
          />
        </CustomModal>
      )}
    </div>
  );
}

export default Sid;
